module.exports = __webpack_public_path__ + "ATS/img/botton_发表.48b66ccf.svg";